var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',_vm._b({attrs:{"id":'div_'+_vm.canvas_id}},'canvas',_vm.canvas_config,false))}
var staticRenderFns = []

export { render, staticRenderFns }